import React from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import { LinkContainer, IndexLinkContainer } from 'react-router-bootstrap';
import Icon from 'react-fa';

import EnabledFeaturesStore from '../stores/EnabledFeaturesStore';
import Logo from './Logo.react';
import SidebarHelpAndSettings from './SidebarHelpAndSettings.react';

const getState = () => ({
  enabledFeatures: EnabledFeaturesStore.getState(),
});

export default class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = getState();
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    this.enabledFeaturesSubscription = EnabledFeaturesStore.addListener(this._onChange);
  }

  componentWillUnmount() {
    this.enabledFeaturesSubscription.remove();
  }

  _onChange() {
    this.setState(getState());
  }

  render() {
    return (
      <aside id='sidebar-wrapper' >
        <Logo />
        <Nav className='sidebar-nav'>
          <IndexLinkContainer to='/'>
            <NavItem><Icon name='eye' fixedWidth /> Overview</NavItem>
          </IndexLinkContainer>
          {
            this.state.enabledFeatures.crosschannel && (
              <LinkContainer to='/my-universes'>
                <NavItem><Icon name='users' fixedWidth /> My Universes</NavItem>
              </LinkContainer>
            )
          }
          {
            this.state.enabledFeatures.content && (
              <LinkContainer to='/content'>
                <NavItem><Icon name='book' fixedWidth /> Content</NavItem>
              </LinkContainer>
            )
          }
          {
            this.state.enabledFeatures.crosschannel && (
              <LinkContainer to='/crosschannel'>
                <NavItem><Icon name='random' fixedWidth /> Cross Channel</NavItem>
              </LinkContainer>
            )
          }
          {
            this.state.enabledFeatures.exporter && (
              <LinkContainer to='/exporter'>
                <NavItem><Icon name='download' fixedWidth /> Data Exporter</NavItem>
              </LinkContainer>
            )
          }
          {
            this.state.enabledFeatures.googledocs && (
              <LinkContainer to='/googledocs'>
                <NavItem><Icon name='google' fixedWidth /> Google Docs</NavItem>
              </LinkContainer>
            )
          }
          {
            this.state.enabledFeatures.reports && (
              <LinkContainer to='/tableau'>
                <NavItem><Icon name='bar-chart' fixedWidth /> Tableau Reports</NavItem>
              </LinkContainer>
            )
          }
          {
            this.state.enabledFeatures.matching && (
              <LinkContainer to='/matching'>
                <NavItem><Icon name='check-circle' fixedWidth /> Data Matching</NavItem>
              </LinkContainer>
            )
          }
          {
            this.state.enabledFeatures.savedjobs && (
              <LinkContainer to='/jobs/new'>
                <NavItem><Icon name='wrench' fixedWidth /> Create a Job</NavItem>
              </LinkContainer>
            )
          }
          {
            this.state.enabledFeatures.jobStatus && (
              <LinkContainer to='/jobs'>
                <NavItem><Icon name='tasks' fixedWidth /> Job Status</NavItem>
              </LinkContainer>
            )
          }
          {
            this.state.enabledFeatures.savedjobs && (
              <LinkContainer to='/savedjobs'>
                <NavItem><Icon name='tasks' fixedWidth /> Saved Jobs</NavItem>
              </LinkContainer>
            )
          }
          {
            this.state.enabledFeatures.syncs && (
              <LinkContainer to='/syncs'>
                <NavItem><Icon name='tasks' fixedWidth /> Sync Status</NavItem>
              </LinkContainer>
            )
          }
        </Nav>
        <h3 className='nav-heading'>Help and Settings</h3>
        <SidebarHelpAndSettings />
      </aside>
    );
  }
}
